"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DifferentiatorPropertyItem = exports.SystemPropertyItem = exports.StyledSystemPropertyContainer = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const PREFIX = "SystemResultsCard";
exports.classes = {
    background: `${PREFIX}-background`
};
exports.StyledSystemPropertyContainer = (0, styles_1.styled)("div")(({ theme }) => ({
    padding: "10px",
    marginTop: "15px"
}));
exports.SystemPropertyItem = (0, styles_1.styled)("div")(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    svg: {
        marginRight: "10px",
        height: "24px",
        width: "24px",
        flexShrink: "0.5",
        flexBasis: "2rem",
        color: theme.colours.inter
    }
}));
exports.DifferentiatorPropertyItem = (0, styles_1.styled)(exports.SystemPropertyItem)(({ theme }) => ({
    backgroundColor: theme.colours.alabaster
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3N5c3RlbS1yZXN1bHRzLWNhcmQvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGlEQUE4QztBQUU5QyxNQUFNLE1BQU0sR0FBRyxtQkFBbUIsQ0FBQztBQUV0QixRQUFBLE9BQU8sR0FBRztJQUNyQixVQUFVLEVBQUUsR0FBRyxNQUFNLGFBQWE7Q0FDbkMsQ0FBQztBQUVXLFFBQUEsNkJBQTZCLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3pFLE9BQU8sRUFBRSxNQUFNO0lBQ2YsU0FBUyxFQUFFLE1BQU07Q0FDbEIsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLGtCQUFrQixHQUFHLElBQUEsZUFBTSxFQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUM5RCxPQUFPLEVBQUUsTUFBTTtJQUNmLFVBQVUsRUFBRSxZQUFZO0lBQ3hCLEdBQUcsRUFBRTtRQUNILFdBQVcsRUFBRSxNQUFNO1FBQ25CLE1BQU0sRUFBRSxNQUFNO1FBQ2QsS0FBSyxFQUFFLE1BQU07UUFDYixVQUFVLEVBQUUsS0FBSztRQUNqQixTQUFTLEVBQUUsTUFBTTtRQUNqQixLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO0tBQzNCO0NBQ0YsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLDBCQUEwQixHQUFHLElBQUEsZUFBTSxFQUFDLDBCQUFrQixDQUFDLENBQ2xFLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNkLGVBQWUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLFNBQVM7Q0FDekMsQ0FBQyxDQUNILENBQUMifQ==